import { render, staticRenderFns } from "./GraduationBillingSection.vue?vue&type=template&id=2665e6c4&scoped=true"
import script from "./GraduationBillingSection.vue?vue&type=script&lang=js"
export * from "./GraduationBillingSection.vue?vue&type=script&lang=js"
import style0 from "./GraduationBillingSection.vue?vue&type=style&index=0&id=2665e6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2665e6c4",
  null
  
)

export default component.exports